import { ref } from 'vue'

export interface CopyFromCustomerRequest {
    customer: Record<string, any>
    at: number
}

export const copyFromCustomerRequest = ref<CopyFromCustomerRequest | null>(null)

export const requestCopyFromCustomer = (customer: Record<string, any>) => {
    copyFromCustomerRequest.value = { customer, at: Date.now() }
}

// Blueprint declares which customer attribute feeds a field via `copyFromCustomer`.
// Returns undefined when the customer has nothing to give, so the field keeps its value.
export const resolveCopiedValue = (customer: Record<string, any>, sourceKey: string) => {
    const value = customer?.[sourceKey]

    return value === null || value === undefined || value === '' ? undefined : value
}
